import React from "react";
import { useSelector } from "react-redux";

import ErrorAlert from "../ErrorAlert";

const ErrorNotification = () => {
  const rawErrorMessages = useSelector((state) => state.error.error);
  if (rawErrorMessages) {
    let errorMessages = [];
    if (Array.isArray(rawErrorMessages)) {
      errorMessages = rawErrorMessages;
    } else if (typeof rawErrorMessages === "string") {
      errorMessages[0] = rawErrorMessages;
    }
    if (errorMessages.length > 0) {
      return <ErrorAlert error={errorMessages} />;
    }
  }
  return null;
};

export default ErrorNotification;
